export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ../~/_@babel_runtime@7.6.2@@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 306
// module chunks = 0